import React from 'react'
import cx from 'classnames'
import styles from './Heading.module.scss'
import { HeadingProps } from '~types'

const Heading = ({
  children,
  level,
  levelDisplay,
  isEyebrow = false,
  isUppercase = false,
  justify = 'left',
  title = '',
  margin,
  gradient = false,
  ...restStyle
}: HeadingProps) => {
  const classNames = cx([
    styles[`heading`],
    styles[`level-${levelDisplay || level}`],
    justify === 'center' && styles[`justify-${justify}`],
    isEyebrow && styles['eyebrow'],
    isUppercase && styles['to-uppercase'],
    gradient && styles['gradient'],
  ])

  const HeadingTag = `h${level}` as keyof JSX.IntrinsicElements

  // Split the title on <br/> and render spans
  const renderTitle = () => {
    if (typeof children === 'string' || typeof title === 'string') {
      const text = typeof children === 'string' ? children : title;
      const lines = text.split(/<br\s*\/?>/i);
      return lines.map((line, index) => (
        <span key={index} className='line-gradient'>
          {line}
        </span>
      ));
    }
    return children;
  }

  return (
    <HeadingTag
      className={classNames}
      style={{ margin, ...restStyle }}
    >
      {renderTitle()}
    </HeadingTag>
  )
}

export default Heading
